import { lazy } from 'react';

const ProfitReportPage = lazy(() => import('../pages/ProfitReport.page'));

const ProfitReportRoutes = [
    {
        path: '/profit-report',
        element: <ProfitReportPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { ProfitReportRoutes };
